'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectControl = function () {
  function SelectControl(element, args) {
    var _this = this;

    _classCallCheck(this, SelectControl);

    var div = document.createElement('div');
    this.select = document.createElement('select');
    this.select.id = window.PRIM.getUUID();
    this.select.disabled = args.readonly ? 'disabled' : '';
    this.select.onchange = args.onchange;
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.select.id;

    if (args.options) {
      args.options.forEach(function (optionItem) {
        var option = document.createElement('option');
        option.innerHTML = optionItem.label;
        option.value = optionItem.value;
        _this.select.appendChild(option);
      });
    }

    this.select.value = args.value ? args.value : '';

    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.select);

    element.appendChild(fragment);
  }

  _createClass(SelectControl, [{
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.select.value ? this.select.value : null;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.select.value = value ? value : '';
    }
  }]);

  return SelectControl;
}();

exports.default = SelectControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/SelectControl.js
// module id = 41
// module chunks = 0